var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", [_c("section", {
    staticClass: "online"
  }, [_c("section", {
    style: {
      background: `url(${_vm.bannerUrl}) no-repeat center 0px`,
      backgroundSize: "cover",
      width: "100%"
    }
  }, [_c("Banner", {
    attrs: {
      imageUrl: _vm.bannerUrl,
      title: "智能外呼",
      description: "智能外呼适用于各类电销、回访、催收、通知等外呼场景，可以对大量、简单、重复耗时的呼叫和记录工作进行自动化处理，快速高效完成外呼任务，帮助企业降本增效。"
    }
  })], 1), _c("div", {
    staticClass: "compare"
  }, [_c("SmartTitle", {
    attrs: {
      title: "低成本、高效率，轻松面对行业竞争",
      desc: "DOES YOUR BUSINESS ENCOUNTER THESE PAIN POINTS?"
    }
  }), _c("div", {
    staticClass: "compare_main"
  }, [_c("Card", {
    attrs: {
      list: _vm.compareList
    }
  })], 1)], 1), _c("div", {
    staticClass: "scenarios"
  }, [_c("SmartTitle", {
    attrs: {
      title: "强大功能，自如应对各种需求",
      desc: "WHAT CAB AN INTELLIGENT OUTBOUND ROBOT OF TONGHUASHUN DO?"
    }
  }), _c("div", {
    staticClass: "scenarios_main"
  }, [_c("FunctionCard", {
    attrs: {
      list: _vm.effectives
    }
  })], 1)], 1), _c("div", {
    staticClass: "bright-port"
  }, [_c("SmartTitle", {
    attrs: {
      title: "特色亮点",
      desc: "THE HIGHLIGHTS"
    }
  }), _c("div", {
    staticClass: "bright-port_main"
  }, [_c("BrightSpot", {
    attrs: {
      list: _vm.smartList
    }
  })], 1)], 1), _c("div", {
    staticClass: "effective"
  }, [_c("div", {
    staticClass: "effective_main"
  }, [_c("audio", {
    ref: "audioEl",
    staticStyle: {
      width: "0",
      height: "0"
    },
    attrs: {
      src: _vm.audioResourse,
      loop: false,
      onPause: _vm.onPause,
      onEnded: _vm.onPause,
      onError: _vm.onPause
    }
  }), _c("p", {
    staticClass: "eTitle"
  }, [_vm._v("场景案例")]), _c("FlowGrid", {
    staticClass: "eItems"
  }, _vm._l(_vm.auditions, function ({
    title,
    desc,
    id
  }) {
    return _c("div", {
      key: id,
      class: ["eItem aItem", _vm.playing && _vm.audio === id ? "playing" : ""]
    }, [_c("h3", [_vm._v(_vm._s(title))]), _c("p", [_vm._v(_vm._s(desc))]), _c("button", {
      staticClass: "auditionBtn aicc-btn",
      on: {
        click: () => _vm.playAudio(id)
      }
    }, [_c("img", {
      attrs: {
        src: require("@/assets/images/outbound-calling/audio.png"),
        alt: ""
      }
    }), _c("span", [_vm._v("点击播放")])])]);
  }), 0)], 1)])]), _c("Cases", {
    attrs: {
      source: "aiProduct"
    }
  }), _c("Appointment2")], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };